import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSaveAdd = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4 4.50015C4 3.67194 4.67188 3 5.5 3V4.50015V16.7951L9.56563 13.8917C9.825 13.7042 10.1781 13.7042 10.4375 13.8917L14.5 16.7951V4.50015H5.5V3H14.5C15.3281 3 16 3.67194 16 4.50015V18.2515C16 18.5328 15.8438 18.789 15.5938 18.9172C15.3438 19.0453 15.0437 19.0234 14.8156 18.8609L10 15.4231L5.18438 18.8609C4.95625 19.0234 4.65625 19.0453 4.40625 18.9172C4.15625 18.789 4 18.5328 4 18.2515V4.50015Z",
		fill: "#0D2976"
	})
});
export default SvgSaveAdd;
